import React, { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Typography,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import "react-medium-image-zoom/dist/styles.css";
import Divider from "@mui/material/Divider";
import "../JaldiLab.css";
import {
  generateOrderedList,
  generateParagraphsWithHeading,
  referenceHtml,
  referenceTootKit,
  paraStyle,
  pointStyle,
  sectionStyle,
  h1style,
  h2style,
  h3style,
  h4style,
  dimensionStyle,
  subHeadingStyle,
  getTextContentHeading,
  DashedBorderStyle,
  DividerBorderStyle,
  tableCellStyle,
  tableCaption,
  subHeadingContent,
} from "./ChapterList";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import ReactHtmlParserComponent from "../../../components/HtmlRenderer/ReactHtmlParserComponent";
import { performGetRequest } from "../../../services/apiServices/AxiosUtils";
import { URLS } from "../../../services/apiServices/service";
import objective from "../../../assets/SvgIcons/obj.svg";
import user from "../../../assets/SvgIcons/users.svg";
import adjacencies from "../../../assets/SvgIcons/adjacencies.svg";
import designConsideration from "../../../assets/SvgIcons/design-consideration.svg";
import Image1 from "../../../assets/Images/Spacing Planning images/siteSecurity.jpg";
import Image2 from "../../../assets/Images/Spacing Planning images/SP_image2.png";
import Image3 from "../../../assets/Images/Spacing Planning images/SP_image3.png";
import Image4 from "../../../assets/Images/Spacing Planning images/SP image4.jpg";
import Image6 from "../../../assets/Images/Spacing Planning images/SP image6.jpg";
import Image7 from "../../../assets/Images/Spacing Planning images/SP image7.jpg";
import Image9 from "../../../assets/Images/Spacing Planning images/Image9.png";
import Image12 from "../../../assets/Images/Spacing Planning images/image12.png";
import Image14 from "../../../assets/Images/Spacing Planning images/SP image 14.jpg";
import Image15 from "../../../assets/Images/Spacing Planning images/SP Image15.jpg";
import Image16 from "../../../assets/Images/Spacing Planning images/Image16.jpeg";
import Image17 from "../../../assets/Images/Spacing Planning images/Image17.png";
import Image18 from "../../../assets/Images/Spacing Planning images/Image18.png";
import Image19 from "../../../assets/Images/Spacing Planning images/SP image19.jpeg";
import Image20 from "../../../assets/Images/Spacing Planning images/Sp image20.jpg";
import Image21 from "../../../assets/Images/Spacing Planning images/SP image21.png";
import Image22 from "../../../assets/Images/Spacing Planning images/SP image22.png";
import Image24 from "../../../assets/Images/Spacing Planning images/SP_image24.jpg";
import Image30 from "../../../assets/Images/Spacing Planning images/SP image30.png";
import familyParking from "../../../assets/Images/Spacing Planning images/familyParking.jpeg";
import accessibleParking from "../../../assets/Images/Spacing Planning images/accessibleParking.jpeg";
import shelter from "../../../assets/Images/Spacing Planning images/shelter.jpeg";
import internalRamps from "../../../assets/Images/Spacing Planning images/internalRamps.jpeg";
import kerbRampsImg from "../../../assets/Images/Spacing Planning images/kerbRamps.jpeg";
import accessibleCorridor from "../../../assets/Images/Spacing Planning images/accessibleCorridor.jpeg";
import entryAndExit from "../../../assets/Images/Spacing Planning images/entry&exit.jpeg";
import managementSystem from "../../../assets/Images/Spacing Planning images/managementSystem.jpeg";
import pickupZone from "../../../assets/Images/Spacing Planning images/pickupZone.jpeg";
import parkingAmbulance from "../../../assets/Images/Spacing Planning images/parkingAmbulance.jpeg";
import secureParkingImg from "../../../assets/Images/Spacing Planning images/secureParking.jpeg";
import stair from "../../../assets/Images/Spacing Planning images/stair.jpg";
import emergency_evacuation from "../../../assets/Images/Spacing Planning images/emergency_evacuation.jpeg";
import accusedBoxImg from "../../../assets/Images/Spacing Planning images/accusedBox.png";
import courtroomImg from "../../../assets/Images/Spacing Planning images/courtroomImg.jpg";
import {
  FigureDesc20,
  FigureDesc21,
  FigureDesc22,
  FigureDesc23,
  FigureDesc24,
  FigureDesc25,
  FigureDesc26,
  FigureDesc27,
  FigureDesc28,
  FigureDesc29,
  FigureDesc30,
  FigureDesc31,
  FigureDesc32,
  FigureDesc33,
  ImageDesc29, ImageDesc30, ImageDesc31, ImageDesc32, ImageDesc33, ImageDesc34, ImageDesc35,
  ImageDesc36, ImageDesc37, ImageDesc38, ImageDesc39, ImageDesc40, ImageDesc41, ImageDesc42, ImageDesc43,
  ImageDesc44, ImageDesc45, ImageDesc46, ImageDesc47, ImageDesc48, ImageDesc49,
} from "../../../utils/tmp/ImageDescription/SpacePlaningID";

const borderColor = "#AAAAAA";
const specialBorderColor = "#F3F3F4";

const referenceStyle = {
  color: "black",
  fontFamily: "GT Super Text",
  fontSize: " 24px",
  fontWeight: "700",
  letterSpacing: "0px",
  textAlign: "left",
  fontStyle: "italic",
  cursor: "pointer",
  marginBottom: "10px",
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F45B69",
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: "16px",
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  [`&.${tableCellClasses.body}`]: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#555555",
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
    lineHeight: "20px",
    textAlign: "left !important",
  },
  "&.bold-text": {
    fontWeight: 700,
  },
  "&:first-child": {
    borderLeft: `1px solid ${specialBorderColor}`,
  },
  "&:last-child": {
    borderRight: `1px solid ${specialBorderColor}`,
  },
  fontFamily: "Lato",
}));

const StyledSubHeading = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#CCE5E5",
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#CCE5E5",
  },
}));

const SpacingPlanning = ({ goToSection }) => {
  const referencesRef = useRef(null);
  const [chapterOverride, setChapterOverride] = useState(null);

  useEffect(() => {
    let isMounted = true;

    performGetRequest(
      `${URLS.JALDI_LAB_CHAPTER}/courtDesignHandbook/spacePlanningCirculation/`
    )
      .then((res) => {
        if (!isMounted) return;
        const data = res?.data?.data;
        if (data?.is_active && data?.content) {
          setChapterOverride(data);
        }
      })
      .catch(() => {
        if (isMounted) setChapterOverride(null);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };
  const reference = (_data, number, isColor = false) => {
    return referenceTootKit(_data, number, handleScrollToReferences, isColor);
  };

  const referenceData = [
    {
      content:
        <>Central Public Works Department, <i>A Handbook of Landscape - A Guide</i> (2013); Ministry of Urban Development, ‘Chapter 6 - Sustainability Guidelines’ in <i>Urban and Regional Development Plans Formulation and Implementation Guidelines</i> (2015), p.199. </>,
    },
    {
      content:
        <>U.S. General Services Administration Public Buildings Service, <i>The Site Security Design Guide,</i> pp. 24-25.</>,
    },
    {
      content: "Harmonised Guidelines 2021, p. 57-63, Chapter 3.",
    },
    {
      content: "NBC (2016), p. 29, Figure 5.",
    },
    {
      content: "NCMS (2012). ",
    },
    {
      content: "NBC (2016), Section 4.5.2. ",
    },
    {
      content:
        "NBC (2016), Section 4.6.2 and Annex H, Clauses 6.4.2.2 and 6.8.1.5. ",
    },
    {
      content: "Harmonised Guidelines 2021, p. 67.",
    },
    {
      content:
        <>Ministry of Housing and Urban Affairs, <i>Harmonised Guidelines and Standards for Universal Accessibility in India (2021)</i></>,
    },
    {
      content: "Centre for Excellence in Universal Design, ‘Built Environment’",
      link: "https://universaldesign.ie/built-environment",
      description:
        "<https://universaldesign.ie/built-environment> [“Built Environment Guidelines”]",
    },
    { content: "Harmonised Guidelines 2021." },
    { content: "Harmonised Guidelines 2021." },
    { content: "Harmonised Guidelines 2021, Section 3.6." },
    { content: "Built Environment Guidelines." },
    { content: "Harmonised Guidelines 2021, Section 3.5.3." },
    { content: "Harmonised Guidelines 2021, Section 3.5." },
    { content: "Built Environment Guidelines." },
    { content: "Harmonised Guidelines 2021." },
    { content: "Built Environment Guidelines." },
    { content: "Harmonised Guidelines 2021." },
    { content: "NCMS (2012)." },
    { content: "Harmonised Guidelines 2021." },
    { content: "NBC 2016, Vol. I Part 4: Fire and Life Safety, Section 4.2." },
    {
      content:
        "NBC 2016, Vol. I Part 4: Fire and Life Safety, Section 4.2.7, p. 27.",
    },
    {
      content:
        "NBC 2016, Vol. I Part 4: Fire and Life Safety, Section 2.24, p. 9.",
    },
    { content: "NBC 2016, Section 4.2." },
    { content: "NBC 2016, Section 4.4.2.4.3.2." },
    { content: "NBC 2016, Section 4.4.2.4.3.2." },
    { content: "Harmonised Guidelines 2021, Section 4.2." },
    { content: "NBC 2016, Part 8: Building Services, Sections 5, 7.1-7.2.4." },
    {
      content:
        "NBC 2016, Vol. I Part 4: Fire and Life Safety, Section 4.2.7, p. 27.",
    },
    { content: "NBC 2016, Part 8: Building Services, Section 4.2.2.1." },
    {
      content:
        <>Ted Prestogeorge, ‘Courtroom design for handicap access’ (<i>Fentress Incorporated,</i> 2 November 2017)</>,
      link: "https://blog.fentress.com/blog/Courtroom-design-for-handicap-access",
      description:
        "<https://blog.fentress.com/blog/Courtroom-design-for-handicap-access>",
    },
    { content: "Harmonised Guidelines 2021, Section 4.7.9." },
    { content: "NBC 2016, Section 4.4.2.4.3.5." },
    { content: "NBC 2016, Section 4.4.2.4.3.5." },
    { content: "Harmonised Guidelines 2021, Section 3.7." },
    {
      content:
        <>‘Justice for All: Designing Accessible Courthouses’ <i>(U.S. Access Board)</i></>,
      link: "https://www.access-board.gov/ada/additional-resources/designing-accessible-courthouses.html",
      description:
        "<https://www.access-board.gov/ada/additional-resources/designing-accessible-courthouses.html> [“Designing Accessible Courthouses”]",
    },
  ];

  const securityZones = [
    {
      zones: 1,
      name: "Neighbourhood",
      specifics: [
        "Depending on the purpose of the site, this may be a region of one or more blocks around the Complex.",
        "Streetscapes, open areas, parking lots, and other frequently used facilities may be included.",
      ],
    },
    {
      zones: 2,
      name: "Standoff Perimeter",
      specifics: [
        "A security perimeter may be used to keep explosives carried by vehicles at a distance, minimising potential damage and harm.",
        "The perimeter may need a secured or unsecured standoff, depending on the risk analysis.",
      ],
    },
    {
      zones: 3,
      name: "Site Access and Parking",
      specifics: [
        "Access to the Court Complex site may be provided by, and controlled by, a number of components and services. Both vehicles and visitors may be inspected in this area.",
      ],
    },
    {
      zones: 4,
      name: "Site",
      specifics: [
        "In order to help discourage or stop the destruction of or harm to the Court Complex once inside the security perimeter, the site zone may include an additional layer of protection or hardening.",
        "The site zone's main function, with a sufficiently fortified perimeter, is to serve more as a welcoming public space, with amenities, programmes, and activities that benefit residents, visitors, and building occupants.",
      ],
    },
    {
      zones: 5,
      name: "Building Envelope",
      specifics: [
        "At the building envelope level, illumination, additional security monitoring by security people or cameras, and control of HVAC vents and air intakes may be incorporated.",
      ],
    },
    {
      zones: 6,
      name: "Management and Building Operations",
      specifics: [
        "Modifications to the Court building's layout and programs, such as relocating high-risk residents inside the building, may be undertaken to strengthen security.",
      ],
    },
  ];

  const everyDayAccess = [
    {
      stakeholder: "Judges",
      accessType: "Permanent",
      privileges: "All Access",
    },
    {
      stakeholder: (
        <>
          Permanent Court Staff (Refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure4")}
          >
            Annexure 4
          </span>
          )
        </>
      ),
      accessType: "Permanent",
      privileges:
        "All Access / Access with Permissions (depending on cadre and scope of duties)",
    },
    {
      stakeholder: (
        <>
          Contractual Staff (Refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure4")}
          >
            Annexure 4
          </span>
          )
        </>
      ),
      accessType: "On Contract",
      privileges:
        "All Access / Access with Permissions (depending on cadre and scope of duties)",
    },
    {
      stakeholder: "Lawyers",
      accessType: "On Bar Roll",
      privileges: "Access with Permissions",
    },
  ];

  const serviceProvideAccess = [
    {
      stakeholder: "Security Service Providers",
      accessType: "Background-Checked ID Card",
      privileges: "Access with Permissions",
    },
    {
      stakeholder: "Canteen & Housekeeping Services",
      accessType: "Background-Checked ID Card. On Contract",
      privileges: "Bi-Annual Access",
    },
    {
      stakeholder: (
        <>
          Shopkeepers & Other Amenities Providers (Refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure4")}
          >
            Annexure 4
          </span>
          )
        </>
      ),
      accessType: "On Tender / On Deputation",
      privileges: "Bi-Annual Access to Service Zone",
    },
    {
      stakeholder: "Maintenance Service Providers",
      accessType: "On Contract",
      privileges: "Need-based Access",
    },
  ];

  const otherStakeAccess = [
    {
      stakeholder: "Litigants",
      accessType: "Day Access",
      privileges: "Need-based Access",
    },
    {
      stakeholder: "Accused / Undertrials",
      accessType: "Day Access",
      privileges: "Need-based Access",
    },
    {
      stakeholder: "Witnesses",
      accessType: "Day Access",
      privileges: "Need-based Access",
    },
    {
      stakeholder: "Escorting Police Officers / Security Staff",
      accessType: "Day Access",
      privileges: "Access with Permissions",
    },
    {
      stakeholder: "Vulnerable Witnesses",
      accessType: "Day Access",
      privileges: "Need-based Access",
    },
    {
      stakeholder: "Accredited Media",
      accessType: "Day Access",
      privileges: "Access with Permissions",
    },
    {
      stakeholder: "General Public",
      accessType: "Day Access",
      privileges: "Need-based Access",
    },
  ];

  // Array for Judge
  const judgeArray = [
    "The entry and exit points for Judges must be private and access-controlled, and restricted for use by the Judges and required Court Staff (with permission).",
    "The Judges’ entry and exit points must be fully secure and no unauthorised entry must be allowed beyond the security transition point mapped for this area.",
    "All corridors and pathways leading to the chambers must be under CCTV surveillance.",
  ];

  // Array for Advocates, Litigants, and Court Staff
  const advocatesArray = [
    <>
      The main entrance to the Courtroom must be a public entrance, for
      Advocates, litigants, and Court Staff, with adequate non-threatening or
      non-intimidating security provisions. For more details, please refer to{" "}
      <span
        onClick={() => goToSection("annexes", "HeadingAnnexure3")}
        style={sectionStyle}
      >
        Annexure 3
      </span>
      .
    </>,
    "In instances where certain spaces are restricted to specific categories of users, these must be secured and only authorised personnel must be allowed beyond the security transition point mapped for this area.",
    "These entry and exit points must be sanitised, and persons must be allowed into the building only after adequate security screening.",
    "All corridors and pathways within these spaces must be under CCTV surveillance.",
    "Wherever possible, specific corridors may be designated for Advocates, for ease of movement between various spaces in the Court Complex.",
  ];

  // Array for Accused Persons
  const accusedArray = [
    <>
      Entrance and exit points for the Accused must be private and fully
      restricted, with maximum security provisions, for the use of the Accused
      and accompanying police authorities/security personnel. For more details,
      please refer to{" "}
      <span
        onClick={() => goToSection("annexes", "HeadingAnnexure3")}
        style={sectionStyle}
      >
        {" "}
        Annexure 3
      </span>
      .
    </>,
    "This area must be fully secured and no unauthorised entry should be allowed beyond the security transition point mapped for this area.",
    <>
      All corridors and pathways within the segregated paths used by the Accused
      must be under CCTV surveillance & continuously manned using triggers based
      on a Video Management System. For more details, please refer to{" "}
      <span
        onClick={() => goToSection("annexes", "HeadingAnnexure3")}
        style={sectionStyle}
      >
        {" "}
        Annexure 3
      </span>
      . Automatic sirens should be invoked in case of any loitering or alarm
      detected by pre-set triggers.
    </>,
    "The segregated paths taken by the Accused should be designed to be less authoritarian and humane, through the use of soft landscape, naturally-lit corridors, greenery and other non-intimidating design features.",
  ];

  // Array for Vulnerable Witnesses
  const vulnerableArray = [
    "Entrance and exit points for the Vulnerable Witnesses must be segregated, secure, and welcoming. Security interventions must be non-threatening and unobtrusive.",
    "The segregated paths leading to the building entrance must be designed to be comfortable and safe through use of greenery, and landscaped features, and provision of natural light and ventilation.",
    "This area must be provided with additional security, and no unauthorised entry must be allowed beyond the security transition point mapped for this area.",
    <>
      The pathway must be designed to be more humane with the use of soft
      landscapes, naturally-lit corridors, greenery, and other non-intimidating
      design features similar to design provided within the VWDC Complex. For
      more details of trauma-informed design considerations, refer to{" "}
      <span
        onClick={() => goToSection("vwdc", "vulnerable-witness")}
        style={sectionStyle}
      >
        {" "}
        Section 2.3.A.
      </span>
    </>,
    "All corridors and pathways within these spaces must be under CCTV surveillance, which must be continuously manned based on a Video Management System to prevent the entry of unauthorised personnel.",
  ];

  // Array for Service Providers
  const serviceProvidersArray = [
    "A separate entrance and exit point may be provided for service providers including building maintenance contractors for plumbing, lighting, electrical, etc., and food catering, cleaning/janitorial services, waste management services etc.",
    "This entry and exit must be manned by security personnel and equipped with adequate security infrastructure such as CCTV cameras and controlled access.",
    "The loading & unloading areas must be specially manned with mobile handheld security elements like metal detection wands, etc., to mitigate any risks or threats.",
  ];

  const DesignConsiderations = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      <>
        The site entrances must have clear pedestrian pathways and connectivity
        to the Court building, with adequate illumination, ramps where required,
        and Tactile Ground Surface Indicators (“TGSIs”) for independent and safe
        access.{reference(referenceData[2], 3)}
      </>,
      "Vehicles and pedestrians must have separate entry/exit points at the site, with separate gates for vehicles wherever possible, to prevent conflict.",
      "Entrances must be clearly demarcated and have accessible and tactile wayfinding signage, including the name of the Court Complex, gate numbers, etc.",
      "The spaces/zones accessed by the Accused must be secure, while ensuring that security interventions ensure that the conditions provided are adequately humane.",
      "The security interventions in all spaces/zones accessed by litigants & other stakeholders should be safe and comfortable without being intimidating.",
    ],
    isImage: true,
  };
  const Adjacencies = {
    icon: <img src={adjacencies} />,
    heading: "Adjacencies",
    data: [
      "The main security cabin/lounge must be located at the primary entrance to the Court Complex, to control the flow of stakeholders moving through the site.",
      "At other secondary entry and exit points, manned stations must be provided for security officials to conduct direct security checks.",
      "During temporary instances where high security is needed, additional manning stations may be set up.",
    ],
    isImage: true,
  };
  const SpecificDesign = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",

    data: [
      "The security cabin and manned stations must be designed to be well-ventilated and accessible to diverse user groups. Provision should be made for adequate ergonomic and comfortable furniture including desks and chairs, and storage space for official documents as well as personal effects belonging to the security personnel. ",

      "Adequate lighting and visibility must be ensured in and around the security cabins and manned stations to enhance safety and security.",

      "All security stations must have access to or be in close proximity to accessible washrooms and drinking water facilities.",

      "The security cabin and manned stations must be designed to ensure orderly and unhindered access to the Court Complex for all users through controlled vehicle movement, based on access privileges, after conducting requisite security checks. The design should also incorporate measures for crowd control and queuing management to prevent congestion and ensure an unhindered flow of people through security checkpoints.",

      "The design should ensure privacy and confidentiality in sensitive security zones such as screening and inspection areas.",

      <>
        The security cabin at the site entrance must have provision for an entry
        book, computer system and IT infrastructure, and a web camera system for
        a Visitor Management System (“VMS”) if required. The security cabin must
        also have adequate security provisions in the form of security cameras
        and emergency communication system to ensure prompt response. For
        further details regarding security systems and equipment to be provided,
        refer to
        <span
          onClick={() => goToSection("annexes", "HeadingAnnexure3")}
          style={sectionStyle}
        >
          {" "}
          Annexure 3
        </span>
        .
      </>,
      "The entrance to the security cabin must have a clear width of 900 mm to ensure accessibility for diverse user groups. ",

      "At least one of the security screeners should have no level difference or barriers to facilitate screening for wheelchair users.",

      "Tactile pavers, audio assistance and appropriate signage must be provided at the entrance. ",
    ],
    isImage: true,
  };

  const externalWalkways = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      "The Court Complex must have designated external paths for vehicular and pedestrian movement from the entrance.",
      <>
        External walkways must have a minimum width of{" "}
        <span style={dimensionStyle}>1200 mm</span> for one-way travel and a
        width of <span style={dimensionStyle}>1800 mm</span> for two-way
        walkways. In exceptional cases, where there may be obstacles on the
        walkway such as around trees, poles, etc., the minimum width must be{" "}
        <span style={dimensionStyle}>1500mm.</span>
        {reference(referenceData[10], 11)}
      </>,
      "The walkway must not have a gradient exceeding 1:20. This gradient requirement is also applicable to the cross slope.",
      <>
        For walkways greater than 60 m in length, resting spaces with street
        furniture may be provided at every{" "}
        <span style={dimensionStyle}>30 m</span> length of the walkway. The
        height of the seats must be between{" "}
        <span style={dimensionStyle}>450 mm-500 mm</span> with a backrest and
        handrests at <span style={dimensionStyle}>700 mm</span> height.
      </>,
      <>
        Covered walkways must have a minimum clear height of{" "}
        <span style={dimensionStyle}>2200 mm.</span>
        {reference(referenceData[11], 12)}
      </>,
      <>
        The walkways must have grab rails on both sides wherever the land
        terrain is sloping or undulating. The grab rails must be of contrasting
        colours, fixed at two levels ranging between{" "}
        <span style={dimensionStyle}>700 to 900 mm</span>.
      </>,
      "The walkway must be smooth, hard, and have a surface made of slip-resistant materials.",
      <>
        The walkways must not have any obstructions or obstacles on them. In
        case of levels, grooves, or gratings, steps may be taken to ensure that
        they do not become inaccessible to diverse users.
        {reference(referenceData[12], 13)} In such cases where there may be
        level differences, the walkway must be highlighted with contrasting
        colours or demarcated with a distinct material change.
        {reference(referenceData[13], 14)}
      </>,
      <>
        The walkways must be well illuminated with lighting fixtures at a
        minimum height of <span style={dimensionStyle}>4 m</span> from ground level, to ensure accessibility for
        persons with low vision.{reference(referenceData[14], 15)}
      </>,
      <>
        Continuous TGSI must be laid on the access routes to make them
        accessible to all users with visual impairments. The TGSIs must not be
        placed on the edge of an access route with a minimum distance of{" "}
        <span style={dimensionStyle}>300 mm</span> from any level change or any
        obstruction.{reference(referenceData[15], 16)}
      </>,
    ],
    isImage: true,
  };

  const internalCorridors = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      "Within the Court building, all pathways must be clear and free of obstructions for all persons including Persons with Disabilities.",
      "In cases where there may be level-differences, a ramp with adequate slope must be provided in the corridor. The ramp must be highlighted with contrasting colours or demarcated with a distinct material change.",
      "A floor plan on each floor, demarcating the location of all spaces and facilities on the floor along with the emergency facilities, must be provided to facilitate easy access especially for those who may be visiting the Court Complex for the first time.",
      <>
        Where there is a reduction in the width of a corridor (for example, due
        to a projecting column or duct), the resulting clear width must not be
        less than <span style={dimensionStyle}>1200 mm</span> and the projection
        must be guarded.{reference(referenceData[16], 17)}
      </>,
      <>
        Within office work areas, the width for accessible routes such as
        corridors must be a minimum of{" "}
        <span style={dimensionStyle}>900 mm</span>. In long paths of travel,
        resting areas must be provided at frequent intervals not exceeding{" "}
        <span style={dimensionStyle}>50 m.</span>
        {reference(referenceData[17], 18)}
      </>,
      "The internal corridors must have adequate fire safety measures such as overhead sprinklers, fire extinguishers, etc., at adequate intervals. Additionally, the means of egress must not be lesser in width than the width of internal access ways/exit doorways.",
      <>
        For exit access, the length of a dead-end corridor must not exceed{" "}
        <span style={dimensionStyle}>15000 mm </span>. For assembly occupancy,
        such as the Courtroom, the dead-end corridor length must not exceed{" "}
        <span style={dimensionStyle}>6000 mm </span>.
      </>,
      <>
        Each Accused waiting area (
        <span
          style={sectionStyle}
          onClick={() => goToSection("waitingArea", "accusedWaiting")}
        >
          Section 2.2.D.
        </span>
        ), lock-up (
        <span
          style={sectionStyle}
          onClick={() => goToSection("judicialLockUp", "lockups")}
        >
          Section 2.7.A.
        </span>
        ) and Visiting Room for the Accused (
        <span
          style={sectionStyle}
          onClick={() => goToSection("visitationRoom", "headingVistingRoom")}
        >
          Section 2.7.B.
        </span>
        ) should be access-controlled with a biometric system, with an auto-lock
        feature within a pre-set time duration. Automatic sirens may be invoked
        in case of any loitering or alarm detected by the pre-set triggers.
      </>,
    ],
    isImage: true,
  };

  const DesignConsiderations2 = {
    icon: <img src={designConsideration} />,
    heading: "Design Considerations",
    data: [
      "All building entrances and exits must be designed taking into consideration all universal accessibility principles such automated doors or power-assisted doors, etc.",
      "All entrances and exits must have a clear door width with adequate illumination, ramps where required, and TGSIs for independent and safe access.",
      "The main entrance to the Court building must lead to a welcoming, user-friendly and well-lit lobby space with adequate pause space.",
      "The exit access to fire-resistant evacuation lifts and refuge areas on each floor should be designed to provide accessibility without steps and signposted with internationally recognized symbols of accessibility.",
      "The entry and exit points should be strategically managed alongside other allied services, such as segregated access to private zones, to ensure a comfortable environment for all users.",
      "In case of any noise sources near the entrance like traffic, trains, etc., the entrance must be planned in such a manner as to avoid the noise transferring into the building.",
      "A legible and accessible information desk must be made available at close proximity to the entrance.",
      "A detailed map of the Court Complex and the stairs and fire escapes showcasing the layout must be provided, so as to ensure easy movement for all users.",
      "Case display screens and a large electronic display panel displaying the Court numbers must be provided in the entry area.",
      "A notice board must also be provided in the entrance hall for displaying important notices.",
      <>
        Unless otherwise specified, all the exits and exit passageways to exit
        discharge must have a clear ceiling height of at least{" "}
        <span style={dimensionStyle}>2.4 m</span>. However, the height of the
        exit door should be at least <span style={dimensionStyle}>2.0 m.</span>
        {reference(referenceData[3], 4)}
      </>,
      "Adequate fire safety measures, sirens and evacuation plans must be in place to ensure a quick and safe evacuation in emergencies through the exit points.",
    ],
    isImage: true,
  };

  const parkingObjectives = {
    icon: <img src={objective} />,
    heading: "Objectives",
    data: [
      <>
        <span style={{ color: "#DC002D" }}>
          Provide accessible parking space
        </span>{" "}
        for ease of access for Persons with Disabilities;
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          Ensure unobstructed and organised movement for all users
        </span>{" "}
        of the Court Complex through design of segregated, secure, and adequate
        parking spaces;
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          Ensure systematic vehicular movement
        </span>{" "}
        by having separate entry and exit points to the parking area for
        different kinds of vehicles; and
      </>,
      <>
        <span style={{ color: "#DC002D" }}>Provide enhanced security</span>{" "}
        ensuring coordination with the security personnel and the Parking &
        Visitor Management Systems.
      </>,
    ],
    isImage: true,
  };

  const stairCasesItem = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      "Each flight of stairs in the Court Complex must have a maximum of 12 steps.",
      <>
        The stairs must have a minimum clear width of{" "}
        <span style={dimensionStyle}>1500 mm</span>.
      </>,
      <>
        The height of each riser must be a maximum of{" "}
        <span style={dimensionStyle}>150 mm</span> high, and the tread must be a
        minimum of <span style={dimensionStyle}>300 mm deep</span>.
      </>,
      "Open risers and transparent treads must not be used in the design of any staircase.",
      <>
        The stair landing must be a minimum of{" "}
        <span style={dimensionStyle}>1200 mm</span> deep. All stair landings
        must be free of all obstacles and the dimensions must be clear of any
        door opening.{reference(referenceData[22], 23)} In order to ensure fire
        safety, all emergency exit doors must not open directly upon a flight of
        stairs, and all such entries must be through a landing, so that such
        doors do not impede the movement of people descending from higher
        floors.
      </>,
      <>
        For non-naturally ventilated areas, at the entrance to the stairwell,
        fire doors with 120 min fire resistance rating must be provided to
        prevent spread of fire and smoke.{reference(referenceData[23], 24)}{" "}
        Additionally, a fire shaft with a protected area of 120 min fire
        resistance rating, comprising protected lobby, staircase and fireman's
        lift, connected directly to exit discharge or through exit passageway,
        must be provided.{reference(referenceData[24], 25)}
      </>,
      <>
        If the fire exit is an internal or an external staircase, it must have
        access to either a street, a verandah, an exit passageway, a refuge area
        or a terrace or roof of the building.{reference(referenceData[25], 26)}
      </>,
      <>
        The minimum width of the internal fire exit staircase in the Court
        Complex must be <span style={dimensionStyle}>1500 mm</span>.
        {reference(referenceData[26], 27)}
      </>,
      <>
        All external fire exit staircases must be directly connected to the
        ground and not be inclined at more than a 45 degree angle from the
        horizontal plane. It must have a straight flight with a minimum{" "}
        <span style={dimensionStyle}>1500 mm</span> width.
        {reference(referenceData[27], 28)}
      </>,
    ],
    isImage: true,
  };

  const liftsItem = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",

    data: [
      "An adequate number of lifts must be provided within the Court Complex, which may be determined by the size of the Court Complex as well as the number of floors.",
      <>
        All lifts within the Court Complex must have a minimum size of{" "}
        <span style={dimensionStyle}>1900 mm x 1900 mm</span> to ensure that the
        lift is accessible to diverse user groups. In such cases where adequate
        space is not available, the lift must be a minimum size of{" "}
        <span style={dimensionStyle}>1500 mm x 1500 mm</span>.
        {reference(referenceData[28], 29)}
      </>,
      <>
        The lift door must have a clear opening of a minimum of{" "}
        <span style={dimensionStyle}>900 mm</span>. The time of the
        automatically closing doors must be a minimum of 5 seconds, with the
        closing speed not exceeding 0.25 m/sec.
      </>,
      "The handrails provided within the lifts must be at an adequate height to be accessible for diverse user groups.",
      "The lifts must have audible announcements, a vision panel for persons with visual impairments, and emergency intercom facilities.",
      <>
        For buildings having a height of{" "}
        <span style={dimensionStyle}>15 m </span> or more, at least one lift must
        be provided which meets the requirements of a fireman's lift.
        {reference(referenceData[29], 30)}
      </>,
      <>
        For non-naturally ventilated areas, at the entrance to the lift lobby,
        fire doors with 120 minutes fire resistance rating must be provided to
        prevent spread of fire and smoke.{reference(referenceData[30], 31)}
      </>,
      <>
        Warning signs must be provided at the appropriate locations against the
        use of the lifts during a fire.{reference(referenceData[31], 32)}
      </>,
      <>
        The Court Complex may also be equipped with wheelchair stair-lifts{" "}
        {reference(referenceData[32], 33)} or platform lifts in instances where
        ramps and lifts cannot be provided.{reference(referenceData[33], 34)}
      </>,
    ],
    isImage: true,
  };

  const rampsItem = [
    {
      icon: <img src={designConsideration} />,
      heading: "Specific Design Considerations",
      items: [
        "All ramps in the Court Complex must have an adequate gradient, sufficient space for manoeuvring, edge protections, grab rails, and a non-slippery surface.",
        <>
          All ramps must have a minimum clear width of{" "}
          <span style={dimensionStyle}>1500 mm</span>, with a maximum gradient
          of <span style={dimensionStyle}>1:12</span>.
        </>,
        <>
          Slip-resistant, round edge handrails must be designed for all ramps to
          ensure a comfortable grip. Handrails must be installed at a height of{" "}
          <span style={dimensionStyle}>750 mm to 900 mm</span> above the floor
          level.
        </>,
        "All handrails must be designed in a contrasting colour scheme with the background.",
        <>
          The slope of a ramp must not exceed 1 in 12 (8 percent), and any
          changes in travel direction in the ramp must be preceded by a landing
          of <span style={dimensionStyle}>1.5 m × 1.5 m</span> size.
          {reference(referenceData[34], 35)}
        </>,
        <>
          Where the ramp is not a part of an accessible route, the ramp landing
          is not required to exceed a minimum of{" "}
          <span style={dimensionStyle}>1250 mm</span> in the direction of
          travel, provided that the ramp has a straight run.
          {reference(referenceData[35], 36)}
        </>,
      ],
    },
    {
      heading: "Kerb Ramps",
      items: [
        <>
          The Court Complex must be equipped with kerb ramps from the parking
          area or alighting area for persons using public transport, to ensure
          easy access into the Court Complex.
          {reference(referenceData[36], 37)}
        </>,
        <>
          The gradient of a kerb ramp must have a minimum clear width of{" "}
          <span style={dimensionStyle}>900 mm</span> with a maximum gradient of{" "}
          <span style={dimensionStyle}>1:12</span>. The flared sides of the kerb
          ramp must have a maximum gradient of{" "}
          <span style={dimensionStyle}>1:10</span>.
        </>,
      ],
    },
    {
      heading: "Internal Ramps",
      items: [
        <>
          For spaces within the Court Complex where there may not be adequate
          space to build a ramp, portable ramps must be provided to make the
          space accessible for all user groups.
          {reference(referenceData[37], 38)}
          <CaptionWithBorders1
            image={[kerbRampsImg]}
            caption={"Image 47: Examples of accessible kerb ramps"}
            creditLabel={"Image Credit"}
            imageCredit={" 369 Ochre Studio"}
            zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc47}
          />
          <CaptionWithBorders1
            image={[internalRamps]}
            caption={
              "Image 48: Examples of accessible internal ramps within the building"
            }
            creditLabel={"Image Credit"}
            imageCredit={" 369 Ochre Studio"}
            zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc48}
          />
        </>,
      ],
    },
    {
      heading: "External Ramps",
      items: [
        "All external ramps must be designed to have shelters over them, to ensure protection from all weather elements such as rain, snow, or extreme sunlight and to ensure all-weather accessibility and usability of the ramps.",
        "All external ramps must be designed with the proper slope and drainage, and slip resistant surfaces, to mitigate the risks of water accumulation. Regular maintenance must also be carried out to prevent wear and tear over time.",
        "Landings on the ramps must be provided at specific intervals to ensure safety and usability of all external ramps.",
      ],
    },
  ];

  const parkingUsers = {
    icon: <img src={user} />,
    heading: "Users",
    data: [
      "Judges",
      "Advocates",
      "Litigants and visiting public",
      "Court Staff",
      "Jail vans and police vehicle drivers",
      "Users of reserved accessible parking",
      "Service providers at loading zones",
      "Ambulance drivers",
    ],
    isImage: true,
  };

  const walkwaysObj = {
    icon: <img src={objective} />,
    heading: "Objectives",
    data: [
      <>
        Ensure that the horizontal access circulation routes within the Court
        Complex are logical, understandable, usable, and as direct as possible
        in order to provide{" "}
        <span style={{ color: "#DC002D" }}>
          easy access to all key facilities;{reference(referenceData[9], 10)}
        </span>
      </>,
      <>
        Provide{" "}
        <span style={{ color: "#DC002D" }}>
          well-maintained circulation routes
        </span>{" "}
        that are free of obstacles and have adequate headroom to ensure that all
        stakeholders can access the spaces within the Court Complex without
        obstructions; and
      </>,
      <>
        Ensure{" "}
        <span style={{ color: "#DC002D" }}>seamless, continuous movement</span>{" "}
        between spaces of the Court Complex by avoiding thresholds at doors, or
        level differences between rooms on the same floor.
      </>,
    ],
    isImage: true,
  };

  const verticalObj = {
    icon: <img src={objective} />,
    heading: "Objectives",
    data: [
      <>
        Ensure that the requirements of various stakeholders for{" "}
        <span style={{ color: "#DC002D" }}>
          {" "}
          independently using and accessing spaces
        </span>{" "}
        within the Court are taken into consideration for all vertical
        circulation routes;{reference(referenceData[18], 19)}
      </>,
      <>
        Consider the{" "}
        <span style={{ color: "#DC002D" }}>
          {" "}
          needs of diverse user groups including first-time visitors
        </span>{" "}
        by providing easily locatable and accessible staircases, lifts, etc.,
        {reference(referenceData[19], 20)} supported with well-defined signage
        and a simplified building plan;
      </>,
      <>
        Ensure that users have{" "}
        <span style={{ color: "#DC002D" }}>
          {" "}
          easy and direct access from the arrival/landing points
        </span>
        , stairs, and lift lobbies to the respective spaces to be accessed
        within the Court Complex;{reference(referenceData[20], 21)}
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          {" "}
          Facilitate movement between floors
        </span>
        , by equipping the building with adequate staircases, ramps, lifts, and
        escalators;{reference(referenceData[21], 22)} and
      </>,
      <>
        Ensure{" "}
        <span style={{ color: "#DC002D" }}>
          {" "}
          clear demarcations with signages
        </span>{" "}
        to direct different stakeholders to facilities that may be used in
        emergency situations such as a fire.
      </>,
    ],
    isImage: true,
  };

  const buildingOrg = [
    {
      heading: "Public zones",
      content: (
        <>
          These are areas accessible to all users, including members of the
          public, litigants, Advocates, and staff. The entrances may have
          security provisions; however, such provisions must not restrict the
          movement of user groups under general circumstances. Courtrooms (
          <span
            onClick={() => goToSection("courtroom", "courtrooms")}
            style={sectionStyle}
          >
            Section 2.1
          </span>
          ), general waiting areas (
          <span
            onClick={() => goToSection("waitingArea", "headingWaitingAreas")}
            style={sectionStyle}
          >
            Section 2.2
          </span>
          ), and common amenities (
          <span
            onClick={() => goToSection("sanitaryProvisions", "commonAmenities")}
            style={sectionStyle}
          >
            Section 3
          </span>
          ) fall within this category.
        </>
      ),
    },
    {
      heading: "Private zones",
      content: (
        <>
          These are areas accessible to certain categories of stakeholders based
          on their designation/role in the Court. The entrances may be
          segregated by additional security and accessible to the authorised
          users such as Judges, Vulnerable Witnesses and designated staff
          members. The spaces discussed in{" "}
          <span
            onClick={() => goToSection("vwdc", "VWDC")}
            style={sectionStyle}
          >
            Sections 2.3-2.7{" "}
          </span>{" "}
          fall within this category.
        </>
      ),
    },
    {
      heading: "Detention zones",
      content: (
        <>
          These are areas accessible to selected/specific stakeholders in order
          to limit their interaction with other stakeholders. The entrances are
          segregated with additional security as well as security personnel
          accompanying the Accused, Undertrials or persons in custody. Accused
          waiting areas (
          <span
            onClick={() => goToSection("waitingArea", "accusedWaiting")}
            style={sectionStyle}
          >
            Section 2.2.D
          </span>
          ) and facilities provided for the Accused (
          <span
            onClick={() => goToSection("judicialLockUp", "HeadingLockups")}
            style={sectionStyle}
          >
            Section 2.7
          </span>
          ) fall within this category.
        </>
      ),
    },
  ];

  const dropOffPickUpZones = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      "The Court Complex must have designated drop-off and pick-up zones.",
      "The drop-off and pick-up bays must be on level ground with clear access, bay markings, and signposting.",
      <>
        The passenger drop-off and pick-up zones must have a vehicular pull-up
        bay of <span style={dimensionStyle}>2500 mm x 6100 mm</span>, with an
        access aisle along the length of the pull-up bay.
      </>,
    ],
    isImage: true,
  };

  const designatedParking = {
    icon: <img src={designConsideration} />,
    heading: "Design Considerations",
    data: [
      "Designated parking spaces must be marked around the main Court Complex, with space allocated for specific users including the Judges, Court staff, ambulances, etc.",
      "The designated spaces must be secured with parking cones, signages, etc.",
      "Segregated and secure parking spaces must be provided for Vulnerable Witnesses, and separately for vehicles in connection with the Accused such as police vans, alighting area for prison vans, etc.",
      "Orderly and unhindered access, with adequate signage, to the predetermined parking must be provided for all users.",
      <>
        Vehicle movement must be controlled based on access privileges, after
        scrutinising the same using the security implements needed as noted in{" "}
        <span
          onClick={() => goToSection("annexes", "HeadingAnnexure3")}
          style={sectionStyle}
        >
          Annexure 3
        </span>
        .
      </>,
      "Local zoning regulations must be taken into account for providing parking spaces in the Court Complex.",
      "All parking spaces must be designed to incorporate eco-friendly features like permeable paving, rainwater harvesting, energy-efficient lighting, etc., to minimise the parking facility's ecological impact.",
    ],
    isImage: true,
  };

  const secureParking = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      "The Court Complex must have adequate segregated and secure parking spaces for different kinds of vehicles (four-wheelers, two-wheelers, etc.,) and for different categories of users.",
      "The parking area must have assigned parking for special vehicles such as vehicles of the CRPF Jawans manning the Court Complex, ambulances, fire engines, jail vans designated to transport Undertrial prisoners, etc.",
      "Space must be allocated in a secured parking area around the main Court Complex for Judges. The area designated for Judges’ parking must have additional security along with a rest area for the accompanying drivers.",
      "An adequate number of designated parking spaces must be reserved for the parking of vehicles of all Court Staff.",
      "Spaces must be allocated in the identified parking area of the main Court Complex for litigants, Advocates, and other visitors to the Court.",
      <>
        Parking spaces must be secured with parking cones and other elements as
        shown in{" "}
        <span
          onClick={() => goToSection("annexes", "HeadingAnnexure3")}
          style={sectionStyle}
        >
          Annexure 3
        </span>
        .
      </>,
      "A covered pathway from the parking area to the entrance of the Court building must be provided, to ensure all-weather movement of all users.",
      "A Parking Management System must be put in place to ensure that the reserved parking spaces for the designated user groups are unoccupied and free of any barriers.",
      <>
        Wherever possible, the basement area of the Court Complex may be used
        for the parking Complex.{reference(referenceData[4], 5)} In such cases,
        all doors leading to the basement must be protected with fire doors with
        a minimum fire rating of 120, except for exit discharge doors from the
        basements.{reference(referenceData[5], 6)} The basement must also be
        equipped with adequate smoke ventilation through adequate air ducts and
        exhaust fans.{reference(referenceData[6], 7)}

        <CaptionWithBorders1
          image={[parkingAmbulance]}
          caption={
            "Image 33: Examples of Segregated and Secure Parking for Ambulance"
          }
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio"}
          height="400px"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc33}
        />
        <CaptionWithBorders1
          image={[secureParkingImg]}
          caption={"Image 34: Examples of Segregated and Secure Parking"}
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio"}
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc34}
        />
      </>,
    ],
    isImage: true,
  };
  const reservedParking = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      "The Court Complex must have reserved parking with adequate facilities for diverse users including the elderly, families with children, Persons with Disabilities, etc., with clearly identified signage.",
      <>
        A minimum of one accessible parking bay with a shelter must be provided
        in the Court building. However, buildings with higher occupancy must
        follow the norm as given in the table below.
        {reference(referenceData[7], 8)}
      </>,
    ],
    isImage: true,
  };
  const reservedParking1 = {
    data: [
      <>
        The designated parking area must be located at a maximum of{" "}
        <span style={dimensionStyle}> 30 m </span> from the building entrance.
        {reference(referenceData[8], 9)} Wherever the accessible parking is at a
        distance from the approach view point, legible signage system and access
        routes must be provided.
      </>,
      "The parking bay must be on level ground with clear access, bay markings and signposting.",
      <>
        Reserved parking bays for adapted scooters, tricycles or other personal
        mobility devices (in two-wheeler category) must have a minimum bay size
        of <span style={dimensionStyle}>3000 mm x 2400 mm</span>.
      </>,
      <>
        The accessible car parking bay must have a minimum size of{" "}
        <span style={dimensionStyle}>5000 mm x 3600 mm</span>.
      </>,
      "A Parking Management System may be put in place to ensure that the reserved bays are unoccupied and free of barriers, and to prevent unauthorised use.",
      "Staff assigned to the accessible parking area must be adequately trained to sensitive responses to diverse user groups.",
    ],
    isImage: true,
  };

  const loadingZones = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",

    data: [
      "Loading zones must be located behind the building and accessed by a service road. At a loading dock, large boxes and equipment are unloaded before being taken into the building or a freight elevator (if needed).",
      "Adequate security must be provided as goods brought into the building must be screened.",
      "Direct approach to the loading/unloading docks may be avoided, as an approaching vehicle could speed up to a point where it could force entry.",
    ],
    isImage: true,
  };

  const prisonVans = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",

    data: [
      <>
        The parking area must be separate from the public parking facilities,
        with adequate signage, and must be enclosed by a secure perimeter with
        access control measures (and any other security measures) to prevent
        unauthorised entry and safeguard the vans. For further details, please
        refer to{" "}
        <span
          style={sectionStyle}
          onClick={() => goToSection("annexes", "HeadingAnnexure3")}
        >
          {" "}
          Annexure 3.{" "}
        </span>
      </>,
      "Designated entry and exit points must be provided to enable seamless movement of prison vans, minimising congestion. Clear and well-defined emergency evacuation routes must be provided to allow swift response in case of emergencies or security threats.",
      "The parking area must be located in close proximity to the pathway leading up to the designated Accused pathways to minimise the time and distance for transporting Accused Persons through the Court Complex. ",
      "The parking facilities must be designed to ensure compliance with all accessibility standards, including designated spaces and ramps for persons with disabilities.",
      "The parking facility must be designed to accommodate peak demand, considering the number of expected prison vans based on Court caseload and hearing schedules.",
    ],
    isImage: true,
  };

  const ObjectivesObject = {
    icon: <img src={objective} />,
    heading: "Objectives",
    data: [
      <>
        <span style={{ color: "#DC002D" }}>
          Provide for universal accessibility{" "}
        </span>
        for diverse user groups, including Persons with Disabilities, the
        elderly, expectant mothers, children, families, all genders, etc., in
        facilities such as parking, public amenities, etc.;
      </>,
      <>
        <span style={{ color: "#DC002D" }}>Consider the various users </span> of
        the Court Complex in site planning, by mapping them vis-à-vis their
        privileges and access needed for their personalised movement, to ensure
        their privacy and address security concerns;
      </>,
      <>
        <span style={{ color: "#DC002D" }}>Ensure ease of orientation</span>{" "}
        within the site by providing accessible wayfinding and
        signage/information systems;
      </>,
      <>
        Ensure that a strategic, effective and long-term flexible approach is
        adopted for the site planning to
        <span style={{ color: "#DC002D" }}>
          {" "}
          anticipate future needs and ensure adaptable design
        </span>
        ;
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          {" "}
          Incorporate site-level security operations and fire safety measures{" "}
        </span>{" "}
        in the site plan, to mitigate/minimise the potential risks;
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          Ensure effective security surveillance{" "}
        </span>{" "}
        and efficiency by providing spaces for crowds and people queuing within
        the Court Complex site to avoid disorder and congestion;
      </>,
      <>
        Ensure that the approach to the site is designed to{" "}
        <span style={{ color: "#DC002D" }}>
          accommodate sustainable transportation options{" "}
        </span>{" "}
        including walking, bicycling and mass transit, and last mile
        connectivity; and
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          Ensure sustainable site planning{" "}
        </span>{" "}
        and landscaping guidelines, including environmentally sensitive and
        context driven design responses.{reference(referenceData[0], 1)}
      </>,
    ],
    isImage: true,
  };

  const SpecificDesignConsiderationsObject = {
    icon: <img src={designConsideration} />,
    heading: "Design Considerations",
    data: [
      "The site design of the Court Complex must take local land use and zonal/building regulations into account.",
      "Site design must consider all universal design principles and guidelines.",
      "Site-specific conditions such as site context, neighbouring development, local climate, geography, seismic zones, site acoustics, etc., and long-term climate change impacts such as drought, flood, wind, and wildfire risks, must be taken into consideration to determine the building location and orientation, location of services and other facilities such as parking etc.",
      "The physical characteristics of the site such as the topography, existing natural features, proximity to major traffic corridors, large utilities such as stormwater drains, etc., and the presence of physical barriers should be considered in orienting and locating the buildings and site security.",
      "The design must incorporate local community symbols and regional requirements to ensure that the design is more contextually responsive.",
      "The site plan must be built to accommodate space for amenities such as post office, bank/ATM facilities, medical supplies, etc., especially if these amenities are not present in proximity to the site location.",
      "The site plan must provide for adequate public sanitary facilities, including accessible toilets and drinking water facilities within the Court Complex site.",
      "The site plan must ensure appropriate locations for Diesel Generator (“DG”) sets and other building services equipment such as the pump room, fire extinguisher, water point, water tanks, etc.",
      <>
        As shown in <span style={{ color: "#DC002D" }}>Figure 20</span>, the site security zones must follow the physical
        layout of a site from the outside (Zone 1) to the inside (Zone 6).
        {reference(referenceData[1], 2)} Every zone must be designed to provide
        chances to improve the site's functionality and overall appearance while
        strengthening security. For example, Zone 1 must take into account a
        site's location within the surrounding area. For each subsequent zone,
        the potential to safeguard the Complex by altering its perimeter,
        circulation, and programme must be taken into account based on the
        surrounding physical context.
      </>,
    ],
    isImage: true,
  };

  const fiveSeparateEntr = [
    "Judges",
    "Court Staff, Lawyers and Litigants (Main gate)",
    "Vulnerable Witnesses",
    "Accused and Undertrials in criminal cases",
    "Service Providers",
  ];
  const accessType = [
    "All Access",
    "Access with Permissions",
    "Access to Public Zone",
    "Access to Service Zone",
    "Bi-Annual Access",
    "Need-based Access",
  ];

  const objectivesAccess = {
    icon: <img src={objective} />,
    heading: "Objectives",
    data: [
      <>
        Ensure that the entrances, exits, and paths adhere to{" "}
        <span style={{ color: "#DC002D" }}>
          {" "}
          universal accessibility principles{" "}
        </span>{" "}
        such as adequate colour contrast, legibility, etc.
      </>,
      <>
        For Vulnerable Witnesses and Accused Persons, ensure that the segregated
        entrances are planned in such a manner that{" "}
        <span style={{ color: "#DC002D" }}> they do not cross paths </span> in
        their entire journey throughout the Court Complex;
      </>,
      <>
        Ensure that all entrances to the Court Complex have{" "}
        <span style={{ color: "#DC002D" }}>
          {" "}
          adequate security provisions;{" "}
        </span>
      </>,
      <>
        Ensure that the security provisions at the entrances are{" "}
        <span style={{ color: "#DC002D" }}>
          {" "}
          non-intimidating and sensitive{" "}
        </span>{" "}
        to the needs of diverse users; and
      </>,
      <>
        Ensure that all Court users, including those on foot or using vehicles,{" "}
        <span style={{ color: "#DC002D" }}>
          follow the designated segregated paths{" "}
        </span>{" "}
        as described in{" "}
        <span
          onClick={() =>
            goToSection("spacePlanningCirculation", "siteEntrances")
          }
          style={sectionStyle}
        >
          Section 1.2.A{" "}
        </span>{" "}
        from the manned stations at transition points to the Court building.
      </>,
    ],
    isImage: true,
  };

  const usersObject = {
    icon: <img src={user} />,
    heading: "Users of the Court Complex",
    isOrdered: false,
  };

  if (chapterOverride?.content) {
    return (
      <div style={{ padding: "32px 0" }}>
        {chapterOverride.title ? (
          <h1 style={h1style}>{chapterOverride.title}</h1>
        ) : null}
        <ReactHtmlParserComponent htmlString={chapterOverride.content} />
      </div>
    );
  }

  return (
    <div>
      <Typography>
        <h1 id="handbookPrinciple" style={h1style}>
          PART C – THE HANDBOOK
        </h1>{" "}
        <p style={paraStyle}>
          <span
            onClick={() =>
              goToSection("spacePlanningCirculation", "handbookPrinciple")
            }
            style={sectionStyle}
          >
            PART C
          </span>{" "}
          utilises the design principles described in{" "}
          <span
            onClick={() => goToSection("designPrinciples", "accessibility")}
            style={sectionStyle}
          >
            PART B, Section 2{" "}
          </span>
          to highlight how a principles-based approach to Court planning would
          work in practice.{" "}
          <span
            onClick={() =>
              goToSection("spacePlanningCirculation", "siteDesign")
            }
            style={sectionStyle}
          >
            Section 1
          </span>{" "}
          discusses the various aspects of spatial planning which must be
          considered from the start of the design process, including overall
          site design and smooth circulation of stakeholders throughout the
          Court Complex.{" "}
          <span
            onClick={() => goToSection("courtroom", "courtrooms")}
            style={sectionStyle}
          >
            Section 2
          </span>{" "}
          dives into the various specific spaces within the Court Complex, and
          provides an ideal vision in line with the principles-based approach.
        </p>
        <h2 id="spacePlanning" style={{ ...h2style, padding: "10px 16px" }}>
          <span style={{ fontSize: "24px" }}>1. </span>
          SPACE PLANNING AND CIRCULATION
        </h2>
        <p style={paraStyle}>
          Space planning and circulation needs consideration at every stage of
          design of a building: from inception to implementation, operation,
          occupancy, and post-occupancy. The planning and organisation of
          functions and activities and the circulation system play a vital role
          in ensuring safety and ease of movement through the Court Complex, at
          both the micro- and macro-levels.
        </p>
        <p style={paraStyle}>
          The planning and design decisions at the building and site levels
          should consider both horizontal and vertical parameters of circulation
          for secure, efficient, and optimal utilisation of space within the
          Court Complex.
        </p>
        <h3 id="siteDesign" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.1. </span>
          Site Design
        </h3>
        <p style={paraStyle}>
          The overall functioning and visual appeal of a Court Complex depends
          on effective site design. Site design requires a comprehensive
          understanding and appreciation of local contextual requirements.
          Strategic site planning objectives must be balanced with available
          local facilities, and take into account the surrounding environment
          and infrastructure.
        </p>
        {getTextContentHeading(ObjectivesObject)}
        {getTextContentHeading(SpecificDesignConsiderationsObject)}
        <div style={{ margin: "30px 0" }}>
          <p className="table-guidance-heading">
            <span className="table-guidline-text">Table 1: </span>
            <br />
            <span style={tableCaption}>Six Security Zones</span>
          </p>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#F45B69" }}>
                  <StyledTableCell>Zones</StyledTableCell>
                  <StyledTableCell>Name</StyledTableCell>
                  <StyledTableCell>Specifics</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {securityZones?.map((zone) => (
                  <StyledTableRow
                    key={zone.zones}
                    style={{ borderBottom: "hidden" }}
                  >
                    <StyledTableCell>{zone.zones}</StyledTableCell>
                    <StyledTableCell>{zone.name}</StyledTableCell>
                    <StyledTableCell>
                      <Typography id="typgraphyList">
                        {zone.specifics.map((detail, index) => (
                          <p
                            key={index}
                            style={{ ...tableCellStyle, paddingLeft: "20px" }}
                          >
                            {detail}
                          </p>
                        ))}
                      </Typography>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <CaptionWithBorders1
          image={[Image1]}
          caption={
            "Figure 20: Six security zones represented on a  hypothetical site"
          }
          isZoom={true}
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc20}
        />
        <CaptionWithBorders1
          image={[Image2]}
          caption={"Figure 21: Site design and security strategies"}
          isZoom={true}
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc21}
        />
        <DashedBorderStyle />
        <h3 id="entrancesAndExits" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.2. </span>
          Entrances and Exits
        </h3>
        <p style={paraStyle}>
          The design of the Court Complex must be planned taking the movement of
          various user groups throughout the Complex into consideration, and
          providing segregated and secure entry and exit points.
        </p>
        <CaptionWithBorders1
          image={[Image3]}
          caption={
            "Figure 22: Segregated entry and exit at site level and building Complex"
          }
          isZoom={true}
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc22}
        />
        {getTextContentHeading(usersObject)}
        {/* <div style={{ display: "flex" }}>
          <img src={user} />
          <h4 id="users-courtroom" style={{ ...h4style, margin: "8px 5px" }}>
            <i>Users of the Court Complex</i>
          </h4>
        </div> */}
        <p style={paraStyle}>
          The security requirements of the Court Complex must be determined by
          undertaking a user mapping, to ensure that the specific needs of
          security and access of all stakeholders are met. The first step in
          such an exercise is to ensure that all distinct stakeholders of the
          system are identified, and their vulnerabilities and threat
          perceptions are mapped. Specific security elements must then be
          introduced to mitigate and manage the risks.
        </p>
        <p style={paraStyle}>
          <span
            style={{
              color: "#DC002D",
            }}
          >
            Five separate entrance/exit points{" "}
          </span>{" "}
          must be provided for the following categories of users:
        </p>
        {generateOrderedList(fiveSeparateEntr)}
        <p style={paraStyle}>
          The different{" "}
          <span style={{ color: "#DC002D" }}>
            {" "}
            categories of access privileges{" "}
          </span>{" "}
          may be granted as follows:
        </p>
        {generateOrderedList(accessType)}
        <div style={{ margin: "30px 0" }}>
          <p className="table-guidance-heading">
            <span className="table-guidline-text">Table 2: </span>
            <br />
            <span style={tableCaption}>
              Access requirements for the different categories of users.
            </span>
          </p>
          <TableContainer sx={{ marginBottom: "30px" }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#F45B69" }}>
                  <StyledTableCell>Stakeholder</StyledTableCell>
                  <StyledTableCell>Access Type</StyledTableCell>
                  <StyledTableCell>Privileges</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledSubHeading>
                  <StyledTableCell colSpan={3}>
                    <p
                      style={{
                        textAlign: "center",
                        margin: "auto",
                      }}
                    >
                      {" "}
                      Everyday Users of the Court Complex
                    </p>
                  </StyledTableCell>
                </StyledSubHeading>
                {everyDayAccess?.map((_data) => (
                  <TableRow>
                    <StyledTableCell> {_data.stakeholder}</StyledTableCell>
                    <StyledTableCell>{_data.accessType}</StyledTableCell>
                    <StyledTableCell>{_data.privileges}</StyledTableCell>
                  </TableRow>
                ))}
                <StyledSubHeading>
                  <StyledTableCell colSpan={3} style={{ textAlign: "center" }}>
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        margin: "auto",
                      }}
                    >
                      {" "}
                      Service Providers
                    </p>
                  </StyledTableCell>
                </StyledSubHeading>
                {serviceProvideAccess?.map((_data) => (
                  <TableRow>
                    <StyledTableCell>{_data.stakeholder}</StyledTableCell>
                    <StyledTableCell>{_data.accessType}</StyledTableCell>
                    <StyledTableCell>{_data.privileges}</StyledTableCell>
                  </TableRow>
                ))}
                <StyledSubHeading>
                  <StyledTableCell colSpan={3} style={{ textAlign: "center" }}>
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        margin: "auto",
                      }}
                    >
                      Other Stakeholders
                    </p>
                  </StyledTableCell>
                </StyledSubHeading>
                {otherStakeAccess.map((_data) => (
                  <TableRow>
                    <StyledTableCell> {_data.stakeholder}</StyledTableCell>
                    <StyledTableCell>{_data.accessType}</StyledTableCell>
                    <StyledTableCell>{_data.privileges}</StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {getTextContentHeading(objectivesAccess)}
        <CaptionWithBorders1
          image={[Image4]}
          caption={"Figure 23: Segregated circulation of various user groups"}
          isZoom={true}
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc23}
        />
        <DividerBorderStyle />
        <h3 id="siteEntrances" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.2.</span>A. Site Entrance & Exit
        </h3>
        {getTextContentHeading(DesignConsiderations)}
        {/* <h4 style={h4style}> */}
        <h3 id="sequence" style={subHeadingStyle}>
          I. Security Cabin and Manned Stations
        </h3>
        {getTextContentHeading(Adjacencies)}
        {getTextContentHeading(SpecificDesign)}
        <DividerBorderStyle />
        <h3 id="buildingEntrances" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.2.</span>B. Building Entrance &
          Exit
        </h3>
        {getTextContentHeading(DesignConsiderations2)}
        <CaptionWithBorders1
          image={[entryAndExit]}
          caption={"Image 29: Examples of building entry and exit"}
          creditLabel="Image Credit"
          imageCredit="369 Ochre Studio"
          isZoom={true}
          zoomImgStyle={{ height: "400px" }}
          imageDescription={ImageDesc29}
        />
        <p style={paraStyle}>
          At the micro level, within the Court Complex, five types of building
          entry/exit points may be distinguished based on the categories of
          users:
        </p>
        <h3 id="sequence" style={subHeadingStyle}>
          I. Judges
        </h3>
        <CaptionWithBorders1
          image={[Image6]}
          caption={"Figure 24: Typical plan of segregated entrance for Judges"}
          isZoom={true}
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc24}
        />
        {generateOrderedList(judgeArray)}
        <h3 id="advocate" style={subHeadingStyle}>
          II. Advocates, Litigants, and Court Staff
        </h3>
        {generateOrderedList(advocatesArray)}
        <CaptionWithBorders1
          image={[Image7]}
          caption={
            "Figure 25: Typical plan of main entrance for Advocates, litigants, and Court Staff"
          }
          isZoom={true}
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc25}
        />
        <h3 id="sequence" style={subHeadingStyle}>
          III. Accused Persons
        </h3>
        {generateOrderedList(accusedArray)}
        <h3 id="sequence" style={subHeadingStyle}>
          IV. Vulnerable Witnesses
        </h3>
        <CaptionWithBorders1
          image={[Image7]}
          caption={
            "Figure 26: Typical plan of segregated entrance for Vulnerable Witnesses"
          }
          isZoom={true}
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc26}
        />
        {generateOrderedList(vulnerableArray)}
        <h3 id="sequence" style={subHeadingStyle}>
          V. Service Providers
        </h3>
        {generateOrderedList(serviceProvidersArray)}
        <CaptionWithBorders1
          image={[Image9]}
          caption={
            "Image 30: Examples of turnstiles used for security purposes"
          }
          creditLabel="Image Credit"
          imageCredit="369 Ochre Studio"
          isZoom={true}
          zoomImgStyle={{ height: "400px" }}
          imageDescription={ImageDesc30}
        />
        <DashedBorderStyle />
        <h3 id="parking" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.3. </span>
          Parking
        </h3>
        <p style={paraStyle}>
          The Court Complex must have adequate space for parking of the vehicles
          of all users. Parking facilities must be accessible, segregated, and
          secure to ensure a smooth flow of movement. Further, the parking staff
          must be sensitised and trained towards responding to diverse user
          groups.
        </p>
        {getTextContentHeading(parkingObjectives)}
        {getTextContentHeading(parkingUsers)}
        {getTextContentHeading(designatedParking)}

        <CaptionWithBorders1
          image={[managementSystem]}
          caption={"Image 31: Example of Parking Management System"}
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio"}
          height="500px"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc31}
          className="image_responsive_lil"
        />
        <DividerBorderStyle />
        <h3 id="dropOff" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.3.</span>A. Drop-Off and Pick-Up
          Zones
        </h3>
        {getTextContentHeading(dropOffPickUpZones)}
        <CaptionWithBorders1
          image={[pickupZone]}
          caption={"Image 32: Examples of Drop-Off and Pick-Up Zones"}
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio"}
          // height="400px"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc32}
        />
        <DividerBorderStyle />
        <h3 id="secureParking" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.3.</span>B. Segregated and Secure
          Parking
        </h3>
        {getTextContentHeading(secureParking)}

        <DividerBorderStyle />
        <h3 id="reservedParking" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.3.</span>C. Reserved Accessible
          Parking
        </h3>
        {getTextContentHeading(reservedParking)}
        <CaptionWithBorders1
          image={[Image12]}
          caption={
            "Image 35: Number of accessible parking bays needed in a building"
          }
          creditLabel={"Source"}
          imageCredit={"Harmonised Guidelines 2021, p. 67"}
          isZoom={true}
          zoomImgStyle={{ height: "200px" }}
          imageDescription={ImageDesc35}
        />
        {getTextContentHeading(reservedParking1)}
        <CaptionWithBorders1
          image={[familyParking]}
          caption={"Image 36: Examples of Accessible Family Parking"}
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio"}
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc36}
        />
        <CaptionWithBorders1
          image={[accessibleParking]}
          caption={"Image 37: Examples of Accessible Parking"}
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio"}
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc37}
        />
        <CaptionWithBorders1
          image={[Image14]}
          isZoom={true}
          caption="Figure 27: Layout representing accessibility and circulation in the parking space"
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc27}
        />
        <CaptionWithBorders1
          image={[Image15]}
          caption={"Figure 28: Plan for accessible reserved parking"}
          isZoom={true}
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc28}
        />
        <DividerBorderStyle />
        <h3 id="loadingZone" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.3.</span>D. Loading Zones
        </h3>
        {getTextContentHeading(loadingZones)}
        <DashedBorderStyle />
        <h3 id="prisonVans" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.3.</span>E. Parking for Prison
          Vans
        </h3>
        {getTextContentHeading(prisonVans)}
        <DashedBorderStyle />
        <h3 id="horizonatalCir" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.4. </span>
          Horizontal Circulation Routes: Walkways and Corridors
        </h3>
        <p style={paraStyle}>
          The site and building organisation are defined by a public, private
          and detention circulation system as follows:
        </p>
        {generateParagraphsWithHeading(buildingOrg)}
        {getTextContentHeading(walkwaysObj)}
        <DividerBorderStyle />
        <h3 id="walkWays" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.4.</span>A. External Environment:
          Walkways
        </h3>
        {getTextContentHeading(externalWalkways)}
        <CaptionWithBorders1
          image={[Image16]}
          caption="Image 38: Accessible pathways with tactile pavers and bollards"
          creditLabel="Image Credit"
          imageCredit="369 Ochre Studio"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc38}
        />
        <CaptionWithBorders1
          image={[Image19]}
          caption="Image 39: Accessible external environment"
          creditLabel="Image Credit"
          imageCredit="369 Ochre Studio"
          height="500px"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc39}
          className="image_responsive_lil"
        />
        <CaptionWithBorders1                                                                                                                  
          image={[Image17]}
          isZoom={true}
          caption="Figure 29: Minimum widths of a clear walkway for diverse user groups"
          creditLabel="Source"
          imageCredit="Adapted from the Harmonised Guidelines 2021, p. 49"
          zoomImgStyle={{ height: "700px" }}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
          imageDescription={FigureDesc29}
        />
        <DividerBorderStyle />
        <h3 id="corridors" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.4.</span>B. Internal Environment:
          Corridors
        </h3>
        {getTextContentHeading(internalCorridors)}
        <CaptionWithBorders1
          image={[Image18]}
          isZoom={true}
          caption={
            "Figure 30: Accessible corridor widths for diverse user groups"
          }
          creditLabel={"Source"}
          imageCredit={"Adapted from the Harmonised Guidelines 2021, p. 49"}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={FigureDesc30}
        />
        <CaptionWithBorders1
          image={[accessibleCorridor]}
          height="500px"
          caption={"Image 40: Examples of accessible corridors"}
          creditLabel={"Source"}
          imageCredit={"369 Ochre Studio"}
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc40}
        />
        <DashedBorderStyle />
        <h3 id="verticalCirculation" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.5. </span>
          Vertical Circulation: Staircases, Lifts, and Ramps
        </h3>
        <p style={paraStyle}>
          The vertical circulation routes in the Court Complex are demarcated
          into the public, private, and detention zone circulation system (Refer
          to{" "}
          <span
            onClick={() =>
              goToSection("spacePlanningCirculation", "horizonatalCir")
            }
            style={sectionStyle}
          >
            Section 1.4.
          </span>)
        </p>
        {getTextContentHeading(verticalObj)}
        <DividerBorderStyle />
        <h3 id="staircases" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.5.</span>A. Staircases
        </h3>
        {getTextContentHeading(stairCasesItem)}
        <CaptionWithBorders1
          image={[Image20]}
          isZoom={true}
          caption={"Figure 31: Details for accessible staircases"}
          creditLabel={"Source"}
          imageCredit={"Adapted from the Harmonised Guidelines 2021, p.165"}
          zoomImgStyle={{ height: "550px" }}
          imageDescription={FigureDesc31}
        />
        <CaptionWithBorders1
          image={[Image21]}
          caption={"Image 41: Specifications for staircases"}
          creditLabel={"Source"}
          imageCredit={"NBC 2016, section 4.2.9"}
          height="400px"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc41}
        />
        <CaptionWithBorders1
          image={[stair]}
          caption={"Image 42: Examples of accessible staircase and escalator"}
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio"}
          height="500px"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc42}
        />
        <CaptionWithBorders1
          image={[emergency_evacuation]}
          caption={
            "Image 43: Example of staircase wheelchair for emergency evacuation"
          }
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio"}
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc43}
        />
        <DividerBorderStyle />
        <h3 id="lifts" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.5.</span>B. Lifts
        </h3>
        {getTextContentHeading(liftsItem)}
        <CaptionWithBorders1
          image={[Image22]}
          caption={"Image 44: Examples of accessible lifts"}
          creditLabel="Image Credit"
          imageCredit="369 Ochre Studio"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc44}
        />
        <CaptionWithBorders1
          image={[Image24]}
          isZoom={true}
          caption={
            "Figure 32: Details for corridors, door clearance, and lifts"
          }
          creditLabel={"Source"}
          imageCredit={"Harmonised Guidelines 2021"}
          zoomImgStyle={{ height: "600px" }}
          imageDescription={FigureDesc32}
        />
        <CaptionWithBorders1
          image={[accusedBoxImg]}
          caption={
            "Image 45: Details for hydraulic lifts for witness and Accused box"
          }
          creditLabel={"Source"}
          imageCredit={"Courtroom Design for Handicap Access"}
          height="400px"
          isZoom={true}
          zoomImgStyle={{ height: "300px" }}
          imageDescription={ImageDesc45}
        />
        <CaptionWithBorders1
          image={[courtroomImg]}
          caption={"Image 46: Examples of mechanical lifts in the witness box"}
          creditLabel={"Source"}
          imageCredit={
            "Courthouse: Courtroom | WBDG - Whole Building Design Guide"
          }
          isZoom={true}
          zoomImgStyle={{ height: "300px" }}
          imageDescription={ImageDesc46}
        />
        <DividerBorderStyle />
        <h3 id="ramps" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.5.</span>C. Ramps
        </h3>
        {subHeadingContent(rampsItem)}
        <CaptionWithBorders1
          image={[Image30]}
          caption={"Figure 33: Plan of accessible external ramp"}
          isZoom={true}
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc33}
        />
        <CaptionWithBorders1
          image={[shelter]}
          caption={
            "Image 49: Examples of accessible external ramps with shelter"
          }
          zoomImgStyle={{ height: "500px" }}
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio "}
          imageDescription={ImageDesc49}
        />
        {/* </div> */}
        <h3 ref={referencesRef} id="spacePlaningRef" style={referenceStyle}>
          References
          <Divider />
        </h3>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
};

export default SpacingPlanning;
